export default __webpack_public_path__ + "5b520ceee624d97486a8a68663f1f5f8.png";